import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import ResourceModal from '@/components/resource/ResourceModal.vue'
import { ResourceChoosedType } from '@/models/types'
import { markRaw, nextTick, onMounted, onUnmounted, ref, watch } from 'vue'
import Quill from 'quill'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'


export default /*@__PURE__*/_defineComponent({
  __name: 'QuillEditor',
  props: {
  content: String
},
  emits: ['change'],
  setup(__props, { emit: __emit }) {

const editorRef = ref()
const resourceModalRef = ref()
const quillEditor = ref()
const _content = ref('')

// eslint-disable-next-line no-undef
const emit = __emit
// eslint-disable-next-line no-undef
const props = __props
const toolbarOptions = [
  ['bold', 'italic', 'underline', 'strike'],
  ['blockquote', 'code-block'],
  [{ 'header': 1 }, { 'header': 2 }],
  [{ 'list': 'ordered' }, { 'list': 'bullet' }],
  [{ 'script': 'sub' }, { 'script': 'super' }],
  [{ 'indent': '-1' }, { 'indent': '+1' }],
  [{ 'direction': 'rtl' }],
  [{ 'size': ['small', false, 'large', 'huge'] }],
  [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
  [{ 'color': [] }, { 'background': [] }],
  [{ 'font': [] }],
  [{ 'align': [] }],
  ['clean'],
  ['link', 'image', 'video']
]

const initEditor = () => {
  const quill = new Quill(editorRef.value, {
    modules: {
      toolbar: toolbarOptions
    },
    theme: 'snow'
  })

  quill.on('text-change', () => {
    const content = quill.getSemanticHTML()

    _content.value = content
    emit('change', content)
  })


  console.log('初始化编辑器')
  quillEditor.value = markRaw(quill)
}

const onChoosed = (e: ResourceChoosedType) => {
  console.log(e)
}

watch(
  () => props.content,
  (newVal) => {
    if (quillEditor.value) {
      if (newVal && newVal !== _content.value) {
        _content.value = newVal
        quillEditor.value.clipboard.dangerouslyPasteHTML(newVal)
      } else if (!newVal) {
        quillEditor.value.setText('')
      }
    }
  }
)

onMounted(() => {
  nextTick(() => {
    initEditor()
  })
})

onUnmounted(() => {
  quillEditor.value = null
  delete quillEditor.value
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      ref_key: "editorRef",
      ref: editorRef,
      style: {"width":"100%","height":"500px"}
    }, null, 512),
    _createVNode(ResourceModal, {
      ref_key: "resourceModalRef",
      ref: resourceModalRef,
      onOk: onChoosed
    }, null, 512)
  ], 64))
}
}

})